import { render, staticRenderFns } from "./ReceteComponent.vue?vue&type=template&id=6280df9e"
import script from "./ReceteComponent.vue?vue&type=script&lang=js"
export * from "./ReceteComponent.vue?vue&type=script&lang=js"
import style0 from "./ReceteComponent.vue?vue&type=style&index=0&id=6280df9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports